import React__default from 'react';

/**
 * Render a `select` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Select(props) {
    return React__default.createElement("select", { ...props });
}

export { Select };
